/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_Reading_On_ScreenInputs */

const en_onboarding_results_reading_on_screen = /** @type {(inputs: Onboarding_Results_Reading_On_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading on screen`)
};

const es_onboarding_results_reading_on_screen = /** @type {(inputs: Onboarding_Results_Reading_On_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo en pantalla`)
};

/**
* | output |
* | --- |
* | "Reading on screen" |
*
* @param {Onboarding_Results_Reading_On_ScreenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_reading_on_screen = /** @type {((inputs?: Onboarding_Results_Reading_On_ScreenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_Reading_On_ScreenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_reading_on_screen(inputs)
	return en_onboarding_results_reading_on_screen(inputs)
});